import { render, staticRenderFns } from "./ManageRolePermissions.vue?vue&type=template&id=badb94a4&"
import script from "./ManageRolePermissions.vue?vue&type=script&lang=js&"
export * from "./ManageRolePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports